import { ResultadoFiltrosDTO } from "./resultadoFiltro.dto";
import { ViajeDTO } from "./viaje.dto";


export class ResponseViajeFiltrosDTO{
    listado: ViajeDTO[];
    filtros: ResultadoFiltrosDTO;
}